
    //Handles Analyzify SS events for analyzifycdn.com
    window.analyzify.initGTAG_SS = (gtag_SSObj) => {
        try {
            window.dataLayer = window.dataLayer || [];
    
            if(!gtag_SSObj) return window.analyzify.log('gtag_SSObj is not found', 'an_gtag_ss', 'initGTAG_SS');
            window.analyzify.log('gtag_SSObj received', 'an_gtag_ss', 'initGTAG_SS');
    
            const gaItemMapper = (product, variantDetails) => {
                try {
    
                    analyzify.log('gaItemMapper: processing product and variant', 'an_gtag_ss', 'gaItemMapper');
    
                    if(!product) analyzify.log('product is not found', 'an_gtag_ss', 'gaItemMapper');
    
                    // Get ID based on format    
                    const getIdByFormat = (format, { product, variant }) => {
                        try {
                        const idMap = {
                            'product_id': () => product?.product_id ||product?.id || null,
                            'variant_id': () => product?.variant_id || variant?.id || null,
                            'product_sku': () => product?.sku || variant?.sku || null
                        };
                
                        return (idMap[format]?.() || idMap['variant_id']?.())?.toString() || null;
                        } catch (error) {
                            console.error("Error getting ID by format:", error);
                            return null;
                        }
                    };
    
                    const itemObj = {
                        item_id: getIdByFormat(gtag_SSObj.product_id_format, { product, variant: variantDetails }),
                        item_name: (product?.product_title || product?.title)?.trim(),
                        affiliation: "Analyzify SS",
                        item_brand: product?.vendor?.trim() || null,
                        item_category: product?.type?.trim() || product?.product_type?.trim() || null,
                        item_sku: variantDetails?.sku?.toString() || null,
                        quantity: product?.quantity || window.analyzify?.findQuantity() || 1,
                        price: variantDetails?.price || window.analyzify.formatPrice(product?.price, true),
                        item_variant: product?.variant_title?.trim() || variantDetails?.title?.trim() || null,
                        item_variant_id: product?.variant_id?.toString() || variantDetails?.id?.toString() || null,
                        item_product_id: product?.product_id?.toString() || product?.id?.toString() || null,
                        item_shopify_id: `shopify_${window.analyzify?.feed_region}_${product.product_id || product?.id}_${product.variant_id || variantDetails?.id}`
                    };
    
                    analyzify.log('itemObj created successfully', 'an_gtag_ss', 'gaItemMapper');
                    return itemObj;
                } catch (error) {
                    console.error("Error mapping item:", error);
                }
            };
    
            const handlePageView = async () => {
                try {
                    // Always send page_view event - the send_SSEventData function will handle cart_attributes
                    analyzify.log('Sending page_view event', 'an_gtag_ss', 'handlePageView');
                    send_SSEventData({ eventName: "page_view" });
                } catch (error) {
                    console.error("Error handling page_view:", error);
                }
            };
    
            const eventQueue = [];
    
            const processEventQueue = async () => {
                try {
                    let processedCount = 0;
                    const maxProcessLimit = 5;
    
                    while (eventQueue.length > 0 && processedCount < maxProcessLimit) {
                        const queuedEvent = eventQueue.shift();
                        await send_SSEventData(queuedEvent);
                        processedCount++;
                    }
                } catch (error) {
                    console.error("Error processing event queue:", error);
                }
            };
    
            if (window.analyzify.consent_active) {
                window.analyzify.consentManager.queueConsentAction((initialConsent) => {
                    
                    analyzify.log('Initial consent received, queue length: ' + eventQueue.length, 'an_gtag_ss', 'AnalyzifyConsent');
    
                    // Store consent data for later use
                    window.analyzify.current_consent = initialConsent;
    
                    const isGranted = initialConsent?.ad_storage === 'granted' && initialConsent?.analytics_storage === 'granted';
                    if (isGranted) {
                        processEventQueue(); // Process queued events when consent is granted
                        analyzify.log('Consent granted - processing queued events', 'an_gtag_ss', 'AnalyzifyConsent');
                    }
                });
    
                window.analyzify.consentManager.onChange((newConsent) => {
                    // Store updated consent data for later use
                    window.analyzify.current_consent = newConsent;
    
                    const isGranted = newConsent?.ad_storage === 'granted' && newConsent?.analytics_storage === 'granted';
                    if (isGranted) {
                        processEventQueue(); // Process queued events when consent is granted
                        analyzify.log('Consent updated - processing queued events', 'an_gtag_ss', 'AnalyzifyConsent');
                    }
                });
            } else {
                // Fallback for when the consent system is disabled entirely.
                // Set default consent to "granted" since consent logic is disabled
                window.analyzify.current_consent = {
                    ad_storage: "granted",
                    analytics_storage: "granted",
                    ad_user_data: "granted",
                    ad_personalization: "granted"
                };
                
                processEventQueue(); // Process queued events when consent is granted
                analyzify.log('Consent system disabled - processing all events', 'an_gtag_ss', 'AnaluzifyConsent');
            }
    
            const send_SSEventData = async (eventObj) => {
                try {
                    setTimeout(async () => {
                        // Check if consent is given
                        const isConsentGiven = !window.analyzify.consent_active || 
                        (
                            window.analyzify.current_consent?.ad_storage === "granted" &&
                            window.analyzify.current_consent?.analytics_storage === "granted"
                        );
    
                        if (!isConsentGiven) {
                            analyzify.log(`Consent not given, event queued: ${eventObj.eventName}`, 'an_gtag_ss', 'send_SSEventData');
                            eventQueue.push(eventObj);
                            return;
                        }
    
                        // Process any queued events first
                        await processEventQueue();
    
                        let cartData = window.analyzify.unformattedCartDataObj
                        // For page_view and view_item events, make sure cart_attributes are loaded
                        if (["page_view", "view_item", ].includes(eventObj.eventName)) {
                            const measurementId = (() => {
                                const getValue = (val) => val && val !== 'null' && val !== 'undefined' ? val : null;
                                const id = getValue(window?.analyzify?.properties?.SERVERSIDE?.measurement_id) ||
                                getValue(window?.analyzify_measurement_id) ||
                                getValue(window?.analyzify?.measurement_id) ||
                                getValue(window?.analyzify?.properties?.GA4?.primary?.id);
                                return id?.toString()?.trim() || null;
                            })();
                            
    
                            // Check if cart_attributes is missing important parameters
                            const hasParams = window.analyzify.cart_attributes && 
                                            Object.keys(window.analyzify.cart_attributes).length > 0 && cartData
                                            
                            // If cart_attributes is empty or missing the key parameters, collect them
                            if (!hasParams) {
                                window.analyzify.log('Cart attributes not ready, collecting now', 'an_gtag_ss', 'send_SSEventData');
                                try {
                                    await window.collectCartData(measurementId);
                                    cartData = window.analyzify.unformattedCartDataObj
                                    console.log('cartData', cartData);
                                } catch (error) {
                                    window.analyzify.log(`Error collecting cart data: ${error}`, 'an_gtag_ss', 'send_SSEventData');
                                }
    
                                window.analyzify.log('Cart attributes collected successfully', 'an_gtag_ss', 'send_SSEventData');
                            }
                        }
                        // Check platform status once (outside retry loop for efficiency) - with safety checks
                        const isFacebookEnabled = Boolean(window.analyzify?.properties?.FACEBOOK?.status);
                        const isTikTokEnabled = Boolean(window.analyzify?.properties?.TIKTOK?.status);
                        
                        // Check if URL contains fbclid parameter
                        const urlParams = new URLSearchParams(window.location.search);
                        const hasFbClidinUrl = urlParams.has('fbclid');
                        
                        // Determine what we need to wait for based on platform status and URL parameters
                        const needsFbp = isFacebookEnabled && !cartData?.fbp;
                        const needsFbc = hasFbClidinUrl && !cartData?.fbc;  // Wait for fbc if fbclid in URL
                        const needsTtp = isTikTokEnabled && !cartData?.ttp;
                        const needsGa = !cartData?.ga;
                        const needsConsent = !window.analyzify.cart_attributes?.azfy_consent;
                        
                        // Only wait if we need specific attributes or for certain events
                        if (["page_view", "view_item", "search"].includes(eventObj.eventName) || 
                            (needsFbp || needsFbc || needsTtp || needsGa || needsConsent)) {
                            
                            let retries = 0;
                            const maxRetries = 10;
                            const retryDelay = 500;
                            
                            const waitForAttributes = () => {
                                return new Promise((resolve) => {
                                    const checkAttributes = () => {
                                        // Re-extract fresh data on each check with error handling
                                        try {
                                            cartData = window.analyzify.unformattedCartDataObj
                                        } catch (error) {
                                            window.analyzify.log(`Error extracting cart attributes in retry: ${error}`, 'an_gtag_ss', 'waitForAttributes');
                                        }
                                        
                                        const hasFbp = cartData.fbp;
                                        const hasFbc = cartData.fbc;
                                        const hasTtp = cartData.ttp;
                                        const hasCartId = window.analyzify.cart_id;
                                        const hasGa = cartData.ga;
                                        const hasConsent = window.analyzify.cart_attributes?.azfy_consent;
                                        
                                        // Check conditions based on platform status and URL parameters
                                        const fbpCondition = isFacebookEnabled ? hasFbp : true;
                                        const fbcCondition = hasFbClidinUrl ? hasFbc : true;  // Wait for fbc if fbclid in URL
                                        const ttCondition = isTikTokEnabled ? hasTtp : true;
                                        
                                        if ((fbpCondition && fbcCondition && hasGa && hasConsent && ttCondition && hasCartId) || retries >= maxRetries) {
                                            window.analyzify.log(`Attributes ready: fbp=${!!hasFbp}(${isFacebookEnabled ? 'req' : 'opt'}), fbc=${!!hasFbc}(${hasFbClidinUrl ? 'req' : 'opt'}), ttp=${!!hasTtp}(${isTikTokEnabled ? 'req' : 'opt'}), ga=${!!hasGa}, cartId=${!!hasCartId}, consent=${!!hasConsent}, retries=${retries}`, 'an_gtag_ss', 'waitForAttributes');
                                            resolve();
                                        } else {
                                            retries++;
                                            window.analyzify.log(`Waiting retry ${retries}/${maxRetries}: fbp=${!!hasFbp}, fbc=${!!hasFbc}, ttp=${!!hasTtp}, ga=${!!hasGa}, cartId=${!!hasCartId}, consent=${!!hasConsent}`, 'an_gtag_ss', 'waitForAttributes');
                                            setTimeout(checkAttributes, retryDelay);
                                        }
                                    };
                                    
                                    checkAttributes();
                                });
                            };
                            
                            await waitForAttributes();
                        }
                        
                        const payload = {
                            eventName: eventObj.eventName,
                            actionSource: "website",
                            url: window?.location?.href || null,
                            title: document?.title || null,
                            device: {
                                screenResolution: `${window.screen.width}x${window.screen.height}`,
                                colors: "24-bit",
                                encoding: document.characterSet || "UTF-8",
                                language: navigator.language || "en-US",
                                viewportSize: `${window.innerWidth}x${window.innerHeight}`
                            },
                            userData: {
                                measurementId: (() => {
                                    const getValue = (val) => val && val !== 'null' && val !== 'undefined' ? val : null;
                                    const id = getValue(window?.analyzify?.properties.SERVERSIDE?.measurement_id) ||
                                    getValue(window?.analyzify_measurement_id) ||
                                    getValue(window?.analyzify?.measurement_id) ||
                                    getValue(window?.analyzify?.properties?.GA4?.primary?.id);
                                    return id?.toString()?.trim() || null;
                                })(),
                                cartId: window.analyzify.cart_id || null,
                                id: window.analyzify.properties?.SERVERSIDE?.store_id || null,
                                storeId: window.analyzify.properties?.SERVERSIDE?.store_id || null,
                                fbp: cartData.fbp || null,
                                fbc: cartData.fbc || null,
                                eventId: window.analyzify.eventId.get(eventObj.eventName == "page_view" ? "default" : eventObj.eventName),
                                gclid: cartData.gclid || null,
                                ttclid: cartData.ttclid || null,
                                fbclid: cartData.fbclid || null,
                                ttp: cartData.ttp || null,
                                ga: cartData.ga || null,
                                sessionId: cartData.sessionId || null,
                                email: window.analyzify?.shopify_customer?.email_address || null,
                                phone: window.analyzify?.shopify_customer?.phone_number || null,
                                address: {
                                    first_name: window.analyzify?.shopify_customer?.first_name || null,
                                    last_name: window.analyzify?.shopify_customer?.last_name || null,
                                },
                                consent: isConsentGiven ||window.analyzify.cart_attributes?.azfy_consent || null
                            },
                            data: eventObj.ecomObj || {}
                        };
    
                        window.analyzify.log('Sending event: ' + eventObj.eventName, 'an_gtag_ss', 'send_SSEventData');
    
                        if(!gtag_SSObj?.endpoint) return window.analyzify.log('Endpoint not found', 'an_gtag_ss', 'send_SSEventData');
                
                        const response = await fetch(gtag_SSObj.endpoint, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            body: JSON.stringify(payload)
                        });
    
                        window.analyzify.log('Response received with status: ' + response.status, 'an_gtag_ss', 'send_SSEventData');
                
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                
                        return response;
                    }, 500);
                } catch (error) {
                    try { window.analyzify.log(error, 'an_gtag_ss', 'send_SSEventData'); } catch(_) {}
                }
            };
            // Define ssCartUpdateFailureEvent after send_SSEventData
            window.analyzify.ssCartUpdateFailureEvent = function (details) {
                try {
                  if (!window.analyzify?.properties?.SERVERSIDE?.sendCartUpdateDebug) {
                    return;
                  }
                  const srv = window.analyzify?.properties?.SERVERSIDE || {};
                  const endpoint = srv.testEndpoint;
                  if (!endpoint) {
                    return window.analyzify.log('SS endpoint not configured', 'an_gtag_ss', 'ssCartUpdateFailureEvent');
                  }
      
                  const nowIso = new Date().toISOString();
                  const traceId = details?.trace_id || window.analyzify.generateEventId('tr', '', `${Date.now()}`);
                  const sessionId = (window.analyzify.storageService && window.analyzify.storageService('sessionId')) || null;
      
                  const consent = window.analyzify?.current_consent || {};
                  const toBool = (v) => v === 'granted' || v === true;
      
                  const payload = {
                    eventName: 'cart_update_failure',
                    actionSource: 'website',
                    url: window?.location?.href || null,
                    title: document?.title || null,
                    device: {
                      screenResolution: `${window.screen.width}x${window.screen.height}`,
                      colors: '24-bit',
                      encoding: document.characterSet || 'UTF-8',
                      language: navigator.language || 'en-US',
                      viewportSize: `${window.innerWidth}x${window.innerHeight}`
                    },
                    userData: {
                      user_agent: navigator.userAgent || null,
                      id: window.analyzify.properties?.SERVERSIDE?.store_id || null,
                      eventId: (window.analyzify?.generateEventId && window.analyzify.generateEventId('ev','cart_update_failure', String(Date.now()))) || traceId || null,
                    },
                    data: {
                      consent: {
                          analytics_storage: toBool(consent.analytics_storage),
                          ad_storage: toBool(consent.ad_storage),
                          ad_user_data: toBool(consent.ad_user_data),
                          ad_personalization: toBool(consent.ad_personalization)
                        },
                      azfy_cart_id: window.analyzify?.cart_id || null,
                      shop_domain: srv?.shop_domain || null,
                      session_id: details?.session_id || sessionId,
                      trace_id: traceId,
                      request_url_path: details?.request_url_path || '/cart/update.js',
                      method: details?.method || 'POST',
                      body_size_bytes: Number(details?.body_size_bytes) || null,
                      attempt_number: Number(details?.attempt_number) || 1,
                      timeout_ms: Number(details?.timeout_ms) || null,
                      status_code: typeof details?.status_code !== 'undefined' ? Number(details.status_code) : null,
                      error_category: details?.error_category || null,
                      error_message_sanitized: details?.error_message_sanitized || null,
                      duration_ms: Number(details?.duration_ms) || null,
                      // Additional diagnostics
                      reason_code: details?.reason_code || null,
                      error_name: details?.error_name || null,
                      did_timeout: (typeof details?.did_timeout === 'boolean') ? details.did_timeout : null,
                      beacon_attempted: (typeof details?.beacon_attempted === 'boolean') ? details.beacon_attempted : null,
                      // Storage diagnostics
                      storage: (function(){
                        const out = { local_enabled: null, session_enabled: null, cookie_enabled: null, local_used_bytes: null, session_used_bytes: null, cookie_test_ok: null };
                        try { const k='__azfy_l__'; localStorage.setItem(k,'1'); out.local_enabled=true; localStorage.removeItem(k); let s=0; for(let i=0;i<localStorage.length;i++){const key=localStorage.key(i); const v=localStorage.getItem(key)||''; s += (key?key.length:0) + v.length;} out.local_used_bytes=s; } catch(_) { out.local_enabled=false; }
                        try { const k='__azfy_s__'; sessionStorage.setItem(k,'1'); out.session_enabled=true; sessionStorage.removeItem(k); let s=0; for(let i=0;i<sessionStorage.length;i++){const key=sessionStorage.key(i); const v=sessionStorage.getItem(key)||''; s += (key?key.length:0) + v.length;} out.session_used_bytes=s; } catch(_) { out.session_enabled=false; }
                        try { const k='__azfy_c__'; document.cookie=`${k}=1; path=/; max-age=5`; out.cookie_enabled=!!navigator.cookieEnabled; out.cookie_test_ok=document.cookie.indexOf(`${k}=1`)!==-1; document.cookie=`${k}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`; } catch(_) { out.cookie_enabled=false; out.cookie_test_ok=false; }
                        return out;
                      })(),
                      // Network hints
                      blocked_by_client_hint: (function(){ try { return /blocked\s*by\s*client|net::err_blocked_by_client|ns_error_dom_bad_uri/i.test(String(details?.error_message_sanitized||'')); } catch(_) { return null; } })(),
                      cors_hint: (function(){ try { return /cors|has been blocked by cors policy/i.test(String(details?.error_message_sanitized||'')); } catch(_) { return null; } })(),
                      mixed_content_hint: (function(){ try { return /mixed\s+content/i.test(String(details?.error_message_sanitized||'')); } catch(_) { return null; } })(),
                      // Runtime diagnostics for debugging
                      transport_hint: details?.transport || null, // optional hint from caller
                      page_url: window?.location?.href || null,
                      referrer: document?.referrer || null,
                      visibility_state: document?.visibilityState || null,
                      online: typeof navigator?.onLine === 'boolean' ? navigator.onLine : null,
                      locale: navigator.language || null,
                      timezone_offset: new Date().getTimezoneOffset(),
                      viewport: `${window.innerWidth}x${window.innerHeight}`,
                      sdk_env: window.analyzify?.testing_environment ? 'staging' : 'production',
                      reported_at: details?.reported_at || nowIso,
                      // Extra env signals
                      origin: window?.location?.origin || null,
                      is_top_level: (function(){ try { return window.top === window; } catch(_) { return null; } })(),
                      fetch_is_native: (function(){ try { return /\[native code\]/.test(String(window.fetch)); } catch(_) { return null; } })(),
                      beacon_supported: (function(){ try { return typeof navigator.sendBeacon === 'function'; } catch(_) { return null; } })(),
                      sw_active: (function(){ try { return !!(navigator.serviceWorker && navigator.serviceWorker.controller); } catch(_) { return null; } })(),
                      sw_registration: (async function(){ try { const regs = await navigator.serviceWorker.getRegistrations(); const r = regs && regs[0]; return r && r.scope ? r.scope : null; } catch(_) { return null; } })(),
                      connection: (function(){
                        try {
                          const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
                          if (!c) return null;
                          return {
                            type: c.type || null,
                            effectiveType: c.effectiveType || null,
                            rtt: typeof c.rtt === 'number' ? c.rtt : null,
                            downlink: typeof c.downlink === 'number' ? c.downlink : null,
                            saveData: !!c.saveData
                          };
                        } catch(_) { return null; }
                      })(),
                      cookie_len: (function(){ try { return (document.cookie || '').length; } catch(_) { return null; } })()
                    }
                  };
      
                  const bodyStr = JSON.stringify(payload);
                  let sent = false;
                  try {
                    if (navigator.sendBeacon) {
                      const blob = new Blob([bodyStr], { type: 'application/json' });
                      sent = navigator.sendBeacon(endpoint, blob);
                    }
                  } catch (_) {}
                  if (!sent) {
                    try {
                      fetch(endpoint, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: bodyStr,
                        keepalive: true,
                        mode: 'no-cors',
                        credentials: 'omit'
                      }).catch(() => {});
                    } catch (_) {}
                  }
      
                  window.analyzify.log('cart_update_failure event emitted', 'an_gtag_ss', 'ssCartUpdateFailureEvent');
                } catch (error) {
                  window.analyzify.log(error, 'an_gtag_ss', 'ssCartUpdateFailureEvent');
                }
              };
    
            // Define ssLogFailureEvent (similar to cart_update_failure)
            window.analyzify.ssLogFailureEvent = function(details) {
                try {
                  const srv = window.analyzify?.properties?.SERVERSIDE || {};
                  const endpoint = srv.testEndpoint;
                  if (!endpoint) {
                    return window.analyzify.log && window.analyzify.log('SS endpoint not configured', 'an_gtag_ss', 'ssLogFailureEvent');
                  }
                  if (!srv.sendLogFailureDebug && !srv.sendCartUpdateDebug) {
                    return;
                  }
    
                  const nowIso = new Date().toISOString();
                  const sessionId = (window.analyzify.storageService && window.analyzify.storageService('sessionId')) || null;
                  const traceId = (window.analyzify?.generateEventId && window.analyzify.generateEventId('tr','log_failure', String(Date.now()))) || null;
                  const consent = window.analyzify?.current_consent || {};
                  const toBool = (v) => v === 'granted' || v === true;
    
                  const payload = {
                    eventName: 'analyzify_log_failure',
                    actionSource: 'website',
                    url: window?.location?.href || null,
                    title: document?.title || null,
                    device: {
                      screenResolution: `${window.screen.width}x${window.screen.height}`,
                      colors: '24-bit',
                      encoding: document.characterSet || 'UTF-8',
                      language: navigator.language || 'en-US',
                      viewportSize: `${window.innerWidth}x${window.innerHeight}`
                    },
                    userData: {
                      user_agent: navigator.userAgent || null,
                      id: window.analyzify.properties?.SERVERSIDE?.store_id || null,
                      eventId: traceId
                    },
                    data: {
                      consent: {
                        analytics_storage: toBool(consent.analytics_storage),
                        ad_storage: toBool(consent.ad_storage),
                        ad_user_data: toBool(consent.ad_user_data),
                        ad_personalization: toBool(consent.ad_personalization)
                      },
                      session_id: details?.session_id || sessionId,
                      trace_id: traceId,
                      log_message: details?.message || null,
                      log_group: details?.group || null,
                      log_nested_group: details?.nested_group || null,
                      error_name: details?.error_name || null,
                      error_message: details?.error_message || null,
                      error_stack: details?.stack || null,
                      // Storage diagnostics
                      storage: (function(){
                        const out = { local_enabled: null, session_enabled: null, cookie_enabled: null, local_used_bytes: null, session_used_bytes: null, cookie_test_ok: null };
                        try { const k='__azfy_l__'; localStorage.setItem(k,'1'); out.local_enabled=true; localStorage.removeItem(k); let s=0; for(let i=0;i<localStorage.length;i++){const key=localStorage.key(i); const v=localStorage.getItem(key)||''; s += (key?key.length:0) + v.length;} out.local_used_bytes=s; } catch(_) { out.local_enabled=false; }
                        try { const k='__azfy_s__'; sessionStorage.setItem(k,'1'); out.session_enabled=true; sessionStorage.removeItem(k); let s=0; for(let i=0;i<sessionStorage.length;i++){const key=sessionStorage.key(i); const v=sessionStorage.getItem(key)||''; s += (key?key.length:0) + v.length;} out.session_used_bytes=s; } catch(_) { out.session_enabled=false; }
                        try { const k='__azfy_c__'; document.cookie=`${k}=1; path=/; max-age=5`; out.cookie_enabled=!!navigator.cookieEnabled; out.cookie_test_ok=document.cookie.indexOf(`${k}=1`)!==-1; document.cookie=`${k}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`; } catch(_) { out.cookie_enabled=false; out.cookie_test_ok=false; }
                        return out;
                      })(),
                      // Network hints derived from error/message text
                      blocked_by_client_hint: (function(){ try { const msg = String(details?.error_message || details?.message || '').toLowerCase(); return /blocked\s*by\s*client|net::err_blocked_by_client|ns_error_dom_bad_uri/.test(msg); } catch(_) { return null; } })(),
                      cors_hint: (function(){ try { const msg = String(details?.error_message || details?.message || '').toLowerCase(); return /cors|has been blocked by cors policy/.test(msg); } catch(_) { return null; } })(),
                      mixed_content_hint: (function(){ try { const msg = String(details?.error_message || details?.message || '').toLowerCase(); return /mixed\s+content/.test(msg); } catch(_) { return null; } })(),
                      page_url: window?.location?.href || null,
                      referrer: document?.referrer || null,
                      visibility_state: document?.visibilityState || null,
                      online: typeof navigator?.onLine === 'boolean' ? navigator.onLine : null,
                      locale: navigator.language || null,
                      timezone_offset: new Date().getTimezoneOffset(),
                      viewport: `${window.innerWidth}x${window.innerHeight}`,
                      sdk_env: window.analyzify?.testing_environment ? 'staging' : 'production',
                      reported_at: details?.reported_at || nowIso
                    }
                  };
    
                  const bodyStr = JSON.stringify(payload);
                  let sent = false;
                  try {
                    if (navigator.sendBeacon) {
                      const blob = new Blob([bodyStr], { type: 'application/json' });
                      sent = navigator.sendBeacon(endpoint, blob);
                    }
                  } catch (_) {}
                  if (!sent) {
                    try {
                      fetch(endpoint, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: bodyStr,
                        keepalive: true,
                        mode: 'no-cors',
                        credentials: 'omit'
                      }).catch(() => {});
                    } catch (_) {}
                  }
                  window.analyzify.log && window.analyzify.log('analyzify_log_failure event emitted', 'an_gtag_ss', 'ssLogFailureEvent');
                } catch (error) {
                  window.analyzify.log && window.analyzify.log(error, 'an_gtag_ss', 'ssLogFailureEvent');
                }
            };
    
            // view_item
            window.analyzify.ssViewItem = async (productObj, variantId) => {
                try {
                    if (!productObj) return analyzify.log("Product object is not found", 'an_gtag_ss', 'ssViewItem');
                    if (!gtag_SSObj?.events?.view_item) return analyzify.log('View item event not found', 'an_gtag_ss', 'ssViewItem');
                    let { product, variant } = productObj;
    
                    if(!product) product = productObj;
    
                    analyzify.log(`ssViewItem called with variantId: ${variantId}`, 'an_gtag_ss', 'ssViewItem');
    
                    const firstVariant = window.analyzify.getFirstVariant(product);
                    const variantDetails = window.analyzify.getVariantDetails(product?.variants, variantId || variant?.id || firstVariant?.id);
                    const price = variantDetails?.price || window.analyzify.formatPrice(product.price, true);
    
                    // Always send view_item event - the send_SSEventData function will handle cart_attributes
                    analyzify.log('Sending view_item event', 'an_gtag_ss', 'ssViewItem');
                    send_SSEventData({
                        eventName: "view_item",
                        ecomObj: {
                            currency: window.analyzify?.currency,
                            value: price || 0,
                            items: [gaItemMapper(product, variantDetails)]
                        }
                    });
                } catch (error) {
                    console.error("Error processing server-side view_item:", error);
                }
            };
    
            // Event handlers
            window.analyzify.ssAddToCart = (productObj, variantId) => {
                try {
                    if (!productObj) return analyzify.log("Product object is not found", 'an_gtag_ss', 'ssAddToCart');
                    if (!gtag_SSObj?.events?.add_to_cart) return analyzify.log('Add to cart event not found', 'an_gtag_ss', 'ssAddToCart');
                    
                    let { product, variant } = productObj;
    
                    if(!product) product = productObj;
    
                    const firstVariant = window.analyzify.getFirstVariant(product);
                    const variantDetails = window.analyzify.getVariantDetails(product?.variants, variantId || variant?.id || firstVariant?.id);
                    const prodQty = analyzify.findQuantity() || product?.quantity || 1;
                    const price = variantDetails?.price || window.analyzify.formatPrice(product.price, true);
                    const value = Number(parseFloat((price * prodQty).toFixed(2)));
    
                    analyzify.log(`ssAddToCart called - variantId: ${variantId}, qty: ${prodQty}, price: ${price}, value: ${value}`, 'an_gtag_ss', 'ssAddToCart');
    
                    send_SSEventData({
                        eventName: "add_to_cart",
                        ecomObj: {
                            currency: window.analyzify?.currency,
                            value: value || 0,
                            items: [gaItemMapper(product, variantDetails)]
                        }
                    });
                } catch (error) {
                    console.error("Error processing server-side add_to_cart:", error);
                }
            };
    
            // begin_checkout
            window.analyzify.ssBeginCheckout = cart => {
                try {
                    if (!cart?.items) return analyzify.log('Cart items not found', 'an_gtag_ss', 'ssBeginCheckout');
                    if (!gtag_SSObj?.events?.begin_checkout) return analyzify.log('Begin checkout event not found', 'an_gtag_ss', 'ssBeginCheckout');
    
                    analyzify.log('ssBeginCheckout called with ' + (cart?.items?.length || 0) + ' items', 'an_gtag_ss', 'ssBeginCheckout');
                    
                    send_SSEventData({
                        eventName: "begin_checkout",
                        ecomObj: {
                            currency: window.analyzify?.currency,
                            value: window.analyzify.formatPrice(cart?.total_price, true),
                            items: cart?.items?.map(item => gaItemMapper(item)) || []
                        }
                    });
                } catch (error) {
                    console.error("Error processing server-side begin_checkout:", error);
                }
            };
    
            // search
            window.analyzify.ssSearch = (searchObj) => {
                try {
                    const { term, resultsCount, searchPerformed, products} = searchObj;
                    analyzify.log('ssSearch', 'an_gtag_ss', 'ssSearch');
                    analyzify.log(`searchTerm: ${term}`, 'an_gtag_ss', 'ssSearch');
    
                    send_SSEventData({
                        eventName: "search",
                        ecomObj: {
                            search_term: term,
                            // results_count: resultsCount,
                            // search_performed: searchPerformed,
                            // items: searchPerformed && resultsCount > 0 ? products?.map(item => gaItemMapper(item)) : []
                        },
                    });
                } catch (error) {
                    console.error("Error processing server-side search:", error);
                }
            };
    
            let lastUrl = location.href;
            handlePageView();
    
            if (window.analyzify.op_cart_data_collection && !window.analyzify.checksendcartdata_status) {
                window.analyzify_checksendcartdata();
            }
    
            // Flush any buffered log failures emitted before ssLogFailureEvent became available
            try {
              if (Array.isArray(window.analyzify?._logFailureBuffer) && window.analyzify._logFailureBuffer.length && typeof window.analyzify.ssLogFailureEvent === 'function') {
                const pending = window.analyzify._logFailureBuffer.splice(0);
                pending.forEach(d => {
                  try { window.analyzify.ssLogFailureEvent(d); } catch(_) {}
                });
              }
            } catch(_) {}
    
            switch (window.analyzify.shopify_template) {
                case "product":
                    window.analyzify.ssViewItem(window.analyzify.getProductObj?.product, window.analyzify.getProductObj?.variant?.id);
                    break;
                case "collection":
                    //..
                    break;
                case "search":
                    window.analyzify.ssSearch(window.analyzify.getSearchObj);
                    break;
                //..
            }
    
            // Event listener for consent changes
            document.addEventListener('AnalyzifyConsent', (e) => {
                try {
                    if (e.detail.consent.ad_storage === "granted" && e.detail.consent.analytics_storage === "granted") {
                        processEventQueue();
                    }
                } catch (error) {
                    console.error("Error processing consent changes:", error);
                }
            });
        } catch (error) {
            console.error("Error initializing GTAG_SS:", error);
        }
    };
    
    if (window.analyzify?.properties?.SERVERSIDE?.status) {
        window.analyzify.initGTAG_SS(window.analyzify?.properties?.SERVERSIDE);
    }
    